import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Button, CircularProgress } from '@material-ui/core';

export default makeStyles((theme) => ({
    page: {
        backgroundColor: theme.palette.primary.main,
        minHeight: '100vh',
        paddingBottom: theme.spacing(15),
    },
    appBarWrapper: {
        flexGrow: 1,
        height: 95,
        display: 'flex',
        alignItems: 'center',
        marginBottom: 45,
    },
    brand: {
        flexGrow: 1,
        '& > a': {
            display: 'inline-block',
        },
    },
    cardHeader: {
        backgroundColor: '#F3F4F8',
        textAlign: 'center',
    },
    cardContent: {
        padding: '24px 112px 80px !important',
        textAlign: 'center',
        transition: 'all ease 300ms',
        [theme.breakpoints.down('xs')]: {
            padding: '24px 54px 80px !important',
        },
    },
    cardContentTitle: {
        fontWeight: 500,
        color: theme.palette.primary.dark,
    },
    cardContentSubTitle: {
        fontSize: theme.spacing(2),
        marginBottom: theme.spacing(2),
        color: theme.palette.primary.dark,
        fontWeight: 400,
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    link: {
        textDecoration: 'underline',
        color: theme.palette.text.primary,
        fontSize: 12,
    },
}));

// eslint-disable-next-line no-unused-vars
export const StyledButton = withStyles((theme) => ({
    root: {
        borderColor: 'white',
        marginLeft: theme.spacing(2),
    },
    label: {
        textTransform: 'capitalize',
        color: 'white',
        fontWeight: 700,
    },
}))(Button);
export const LoadingIcon = withStyles((theme) => ({
    circle: {
        color: 'white',
    },
}))(CircularProgress);
